import _concat from "lodash/concat";
import contacts from "./contacts";

export default {
  path: "/contacts",
  component: () => import("@/layouts/FullLayout"),
  children: _concat(contacts)
};
